module.exports = __webpack_public_path__ + "img/liverpool.c7d908be.png";